import { render, staticRenderFns } from "./EnglishSubmitVerify.vue?vue&type=template&id=1b9b8040&scoped=true"
import script from "./EnglishSubmitVerify.vue?vue&type=script&lang=js"
export * from "./EnglishSubmitVerify.vue?vue&type=script&lang=js"
import style0 from "./EnglishSubmitVerify.vue?vue&type=style&index=0&id=1b9b8040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9b8040",
  null
  
)

export default component.exports